import { render } from "./ViewEditor.vue?vue&type=template&id=bcc08b8c&scoped=true"
import script from "./ViewEditor.vue?vue&type=script&lang=ts"
export * from "./ViewEditor.vue?vue&type=script&lang=ts"

import "./ViewEditor.vue?vue&type=style&index=0&id=bcc08b8c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bcc08b8c"

export default script